export const parseCertNames = names => {
    return names.split(",").reduce((acc, subject) => {
        const [key, name] = subject.split("=");
        const clearKey = key.replace(/\s+/g, "");
        acc[clearKey] = name;

        return acc;
    }, {});
};

export const getAlgorithmName = async cert => {
    const pubKey = await cert.PublicKey();
    const algo = await pubKey.Algorithm;
    return await algo.FriendlyName;
};

export const getProviderName = async cert => {
    const hasPrivateKey = await cert.HasPrivateKey();

    if (!hasPrivateKey) return "-";

    const privateKey = await cert.PrivateKey;
    return privateKey.ProviderName;
};

export const getCertStatus = async cert => {
    const now = new Date();
    const validFromDate = new Date(cert.validFrom);
    const validToDate = new Date(cert.validTo);
    const hasPrivateKey = await cert._cadesCertificate.HasPrivateKey();
    const validator = await cert._cadesCertificate.IsValid();
    const isValid = await validator.Result;

    if (now < validFromDate) {
        return "Срок действия не наступил";
    } else if (now > validToDate) {
        return "Срок действия истек";
    } else if (!hasPrivateKey) {
        return "Нет привязки к закрытому ключу";
    } else if (!isValid) {
        return "Ошибка при проверке цепочки сертификатов";
    } else {
        return "Действителен";
    }
};
